import { useGetMany } from "react-admin";
import { Grid, Typography } from "@mui/material";
import { studentRequests } from "api/studentApi";
import StudyGroupField from "server/components/Fields/StudyGroupField";
import { curriculumStudyGroupsMapKey } from "./utils";

// One study-groups input per selected curriculum. Sources are relative, so inside the
// create form's slot iterator they scope to the slot automatically; in the flat edit form
// they live at the form root.
const CurriculumStudyGroupsInput = ({ curriculumIds = [] }) => {
  const { data: curriculums } = useGetMany(
    studentRequests.getCurriculumsSelect(),
    { ids: curriculumIds },
    { enabled: curriculumIds.length > 0 },
  );

  return (
    <Grid
      container
      spacing={2}
    >
      {curriculumIds.map(curriculumId => (
        <Grid
          item
          xs={12}
          md={4}
          key={curriculumId}
        >
          <Typography variant="body2">
            {curriculums?.find(curriculum => curriculum.id === curriculumId)?.name ?? `Учебен план ${curriculumId}`}
          </Typography>
          <StudyGroupField
            source={curriculumStudyGroupsMapKey(curriculumId)}
            label="Оставете празно за всички групи от този учебен план!"
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default CurriculumStudyGroupsInput;
